export const mainPdfLoading = state => state.store.mainPdfReducer.loading;

export const mainPdfError = state => state.store.mainPdfReducer.error;

export const mainPdfData = ({store}) =>store.mainPdfReducer.data